var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4141,
    cy: 26.5156,
    r: 22.5,
    fill: "#E9EBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.791 36.1982C46.396 37.2354 46.0503 38.4453 45.0996 39.0503C44.7539 39.2231 44.4082 39.3096 44.0625 39.3096C43.2847 39.3096 42.5933 38.9639 42.2476 38.3589L38.5312 31.9634V54.5205C38.5312 55.7305 37.5806 56.5947 36.457 56.5947C35.2471 56.5947 34.3828 55.7305 34.3828 54.5205V42.7666H31.6172V54.5205C31.6172 55.7305 30.4937 56.5947 29.4565 56.5947C28.333 56.5947 27.4688 55.7305 27.4688 54.5205V31.9634L23.666 38.3589C23.3203 38.9639 22.6289 39.3096 21.8511 39.3096C21.5054 39.3096 21.1597 39.2231 20.814 39.0503C19.8633 38.4453 19.5176 37.2354 20.1226 36.1982L25.3945 27.21C26.7773 24.8765 29.2837 23.4072 31.9629 23.4072H33.9507C36.6299 23.4072 39.1362 24.8765 40.519 27.21L45.791 36.1982ZM34.3828 38.6182V27.6421C34.21 27.6421 34.0371 27.5557 33.9507 27.5557H31.9629C31.8765 27.5557 31.7036 27.6421 31.6172 27.6421V38.6182H34.3828ZM33 20.6416C30.6665 20.6416 28.8516 18.8267 28.8516 16.4932C28.8516 14.2461 30.6665 12.3447 33 12.3447C35.2471 12.3447 37.1484 14.2461 37.1484 16.4932C37.1484 18.8267 35.2471 20.6416 33 20.6416Z",
    fill: "#0C41C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPa);
export default __webpack_public_path__ + "static/media/pa.35b11e7f5a4acf13758a3380b452f24e.svg";
export { ForwardRef as ReactComponent };